import React from 'react'
import { Grid } from '@mui/material'
import JobTextField from 'components/Drawers/JobDrawer/JobTextField'
import JobMultiSelectTextField from 'components/Drawers/JobDrawer/JobMultiSelectTextField'
import {
  practiceTypeOptions,
  shiftTypeOptions,
} from 'components/Drawers/JobDrawer/constants'
import { PRACTICE_TYPE_HELPER_TEXT } from 'data/fieldHelperText'

const BasicsSection = ({
  values,
  setState,
  showError,
  candidateTypeOptions,
  formSpecialties,
  formSubspecialties,
  setJobAlertData,
}) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <JobTextField
          required
          label='Job Title'
          name='title'
          showError={showError}
          value={values.title}
          setState={setState}
          setJobAlertData={setJobAlertData}
        />
      </Grid>
      <Grid item xs={12}>
        <JobTextField
          required
          label='Profession'
          name='candidateTypeId'
          showError={showError}
          value={values.candidateTypeId}
          options={candidateTypeOptions}
          setState={setState}
          setJobAlertData={setJobAlertData}
        />
      </Grid>
      {formSpecialties.length > 0 && (
        <Grid item xs={6}>
          <JobMultiSelectTextField
            label='Specialties'
            name='specialtyIds'
            value={values.specialtyIds || []}
            options={formSpecialties}
            setState={setState}
            setJobAlertData={setJobAlertData}
          />
        </Grid>
      )}
      {formSubspecialties.length > 0 && (
        <Grid item xs={6}>
          <JobMultiSelectTextField
            label='Subspecialties'
            name='subspecialtyIds'
            value={values.subspecialtyIds || []}
            options={formSubspecialties}
            setState={setState}
            setJobAlertData={setJobAlertData}
          />
        </Grid>
      )}
      <Grid item xs={12} container spacing={2}>
        <Grid item xs={6}>
          <JobTextField
            required
            label='Practice Type'
            name='practiceType'
            showError={showError}
            value={values.practiceType}
            options={practiceTypeOptions}
            setState={setState}
          />
        </Grid>
        {values.candidateTypeId === 2 && (
          <Grid item xs={6}>
            <JobTextField
              label='Shift Type'
              name='shiftType'
              showError={showError}
              value={values.shiftType}
              options={shiftTypeOptions}
              setState={setState}
              toolTipText={PRACTICE_TYPE_HELPER_TEXT}
            />
          </Grid>
        )}
      </Grid>
      <Grid item xs={12}>
        <JobTextField
          label='External Link'
          name='link'
          value={values.link}
          setState={setState}
        />
      </Grid>
    </Grid>
  )
}

export default BasicsSection
